"use client";
import React from "react";
import { IconGroup } from "../../design1/components/Listing";
import { IconFan } from "../../design3/components/Highlighted";
import { camelCaseToWords } from "../../design1/components/Listing";
import {
  CameraIcon,
  VideoIcon,
  AddressIcon,
  HomeIcon,
  getTypeColor,
} from "../../design1/components/Listing";
import { ReviewIcon } from "../../design1/components/Listing";
import { SizeIcon } from "../../design1/components/Listing";

import Button from "../../../ui/Button";
import Link from "next/link";

import { PropertyType } from "../../../../../types";
import { getCurrencySign } from "src/app/lib/getCurrencySign";
import { generateSlugWithId } from "src/app/serverUtils";

interface ExtendedProperty extends PropertyType {
  className?: string;
}
export const CardVariant2: React.FC<ExtendedProperty> = ({
  images,
  title,
  address,
  reviews,
  size,
  price,
  type,
  beforePrice,
  videoLink,
  currency,
  strike,
  id,
  quote,
  quotePrice,
  priceType,
  category,
  className,
}) => {
  const slugwithid = generateSlugWithId(Number(id), title);

  const baseUrl = `/properties/${
    type === "short let" ? "shortlet" : type
  }/${slugwithid}`;

  const formattedCurrency = getCurrencySign(currency);

  return (
    <Link
      href={baseUrl}
      style={{
        boxShadow: "0px 2px 10px 0px rgba(33, 33, 33, 0.05)",
      }}
      className={`flex mx-auto p-4   text-primary bg-white border overflow-hidden rounded-2xl ${className}`}
    >
      <div className="first xxs:w-[40%]  group relative w-[35%]">
        <div className="hover group-hover:flex hidden rounded-md transition-all h-full duration-500 absolute bg-black/60 items-center justify-center z-10 top-0 left-0 w-full">
          <Button className="bg-white !px-2 !text-sm whitespace-nowrap  !text-themeColor w-max h-max">
            View Details
          </Button>
        </div>
        <div className="image h-[200px] min-h-full rounded-md overflow-hidden relative">
          <div
            className="bottom text-black absolute flex 
        gap-2 bottom-4 right-4"
          >
            <span className="bg-brand-light flex gap-1 items-center rounded-sm p-[0.3rem] py-[0.2rem] text-[8px]">
              <CameraIcon /> +{images.length}
            </span>
            {videoLink && (
              <span className="bg-brand-light flex gap-2 items-center rounded-sm p-[0.4rem] py-[0.2rem] text-[8px]">
                <VideoIcon />
              </span>
            )}
          </div>
          <img
            src={images[0]}
            alt={title}
            className="w-full h-full  object-cover rounded-l-md"
          />
          <div
            className={`tag absolute capitalize w-[165px] py-1 text-center text-[11px] left-[-60px] transform origin-center rotate-[-40deg] top-[4%] ${getTypeColor(
              type
            )}`}
          >
            <span>{type !== "short let" && "For"}</span> {type}
          </div>
        </div>
      </div>
      <div className="second  xxs:w-[60%] w-[65%] p-4">
        <div className="first text-sm mb-4">
          <div className="font-semibold text-base mb-2 truncate-2-lines">
            {title}
          </div>
          <IconGroup className="!text-sm">
            <span className="block">
              <AddressIcon />
            </span>{" "}
            <span className="truncate">{address}</span>
          </IconGroup>
        </div>
        <div className="flex flex-wrap gap-2 justify-between">
          <IconGroup className="!text-sm !gap-1">
            <HomeIcon /> {category}
          </IconGroup>
          <IconGroup className="!text-sm !gap-1">
            <ReviewIcon /> {reviews.length} reviews
          </IconGroup>
          <IconGroup className="-ml-[2px] !gap-1  !text-sm block">
            <SizeIcon />
            <span>{size!.toLocaleString()} sqm</span>
          </IconGroup>
        </div>

        <div className="last flex items-center gap-2  border-t pt-3 border-t-disabled2-main mt-3">
          <div className="">
            <h4 className="font-semibold xxs:flex-col xxs:items-start leading-6 items-end gap-1 flex text-themeColor ">
              {formattedCurrency}
              {price.toLocaleString()}
              {beforePrice && strike ? (
                <span className="text-[13px]  leading-none line-through whitespace-nowrap text-secondary-main">
                  {beforePrice.toLocaleString()}
                </span>
              ) : (
                <span className="text-[13px] leading-none whitespace-nowrap text-secondary-main">
                  {camelCaseToWords(priceType)}
                </span>
              )}
            </h4>
            <span className="text-[13px] capitalize text-secondary-main">
              <span className="text-themeColor">
                {" "}
                <span className="text-themeColor text-[14px]">
                  {typeof quotePrice === "number" ? (
                    <span>
                      {formattedCurrency}
                      {quotePrice.toLocaleString()}{" "}
                    </span>
                  ) : (
                    <span>{quotePrice}</span>
                  )}
                </span>
              </span>
              / {quote}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export const CardVariant3: React.FC<ExtendedProperty> = ({
  images,
  title,
  address,
  reviews,
  size,
  price,
  type,
  beforePrice,

  currency,
  strike,
  id,
  quote,
  quotePrice,
  priceType,
  category,
  className,
}) => {
  const slugwithid = generateSlugWithId(Number(id), title);
  const baseUrl = `/properties/${
    type === "short let" ? "shortlet" : type
  }/${slugwithid}`;
  const formattedCurrency = getCurrencySign(currency);
  return (
    <Link
      href={baseUrl}
      style={{
        boxShadow: "0px 2px 10px 0px rgba(33, 33, 33, 0.05)",
      }}
      className={`flex mx-auto p-4   text-primary bg-white border overflow-hidden rounded-2xl ${className}`}
    >
      <div className="first  group relative w-[35%]">
        <div className="hover group-hover:flex hidden rounded-md transition-all h-full duration-500 absolute bg-black/60 items-center justify-center z-10 top-0 left-0 w-full">
          <Button className="bg-white !px-2 !text-sm whitespace-nowrap  !text-themeColor w-max h-max">
            View Details
          </Button>
        </div>
        <div className="image h-[200px] min-h-full rounded-md overflow-hidden relative">
          <img
            src={images[0]}
            alt={title}
            className="w-full h-full  object-cover rounded-l-md"
          />
          <div className="flex w-full px-1 absolute bottom-1 items-center justify-between">
            <div className=" bg-white text-sm rounded-md text-themeColor p-1 left-1">
              {category}
            </div>
            <div
              className="bottom text-white flex 
                    gap-2 bottom-2 right-2"
            >
              <span className=" flex gap-1 bg-[#2F364B99]/60 px-2 rounded-md items-center  p-1 text-sm">
                {images.length} <IconFan />
              </span>
            </div>
          </div>
          <div
            className={`tag absolute capitalize text-[11px] p-1 rounded-md text-center left-2 top-2 transform origin-center ${getTypeColor(
              type
            )}`}
          >
            <span>{type !== "short let" && "For"}</span> {type}
          </div>
        </div>
      </div>
      <div className="second w-[65%] p-4">
        <div className="first text-sm mb-4">
          <h4 className="font-semibold h6 mb-2 truncate-2-lines">{title}</h4>
          <IconGroup className="!text-sm">
            <AddressIcon /> <span className="truncate">{address}</span>
          </IconGroup>
          <div className="flex flex-col">
            <IconGroup className="!text-sm !gap-1">
              <ReviewIcon /> {reviews.length} reviews
            </IconGroup>
            <IconGroup className="-ml-[2px] !gap-1  !text-sm block">
              <SizeIcon />
              <span>{size!.toLocaleString()} sqm</span>
            </IconGroup>
          </div>
        </div>

        <div className="last flex items-center gap-2  border-t pt-3 border-t-disabled2-main mt-3">
          <div className="">
            <h4 className="font-semibold leading-6 items-end gap-1 flex text-themeColor ">
              {formattedCurrency}
              {price.toLocaleString()}
              {beforePrice && strike ? (
                <span className="text-[13px]  leading-none line-through whitespace-nowrap text-secondary-main">
                  {beforePrice.toLocaleString()}
                </span>
              ) : (
                <span className="text-[13px] leading-none whitespace-nowrap text-secondary-main">
                  {camelCaseToWords(priceType)}
                </span>
              )}
            </h4>
            <span className="text-[13px] capitalize text-secondary-main">
              <span className="text-themeColor">
                {" "}
                <span className="text-themeColor text-[14px]">
                  {typeof quotePrice === "number" ? (
                    <span>
                      {" "}
                      {formattedCurrency}
                      {quotePrice.toLocaleString()}{" "}
                    </span>
                  ) : (
                    <span>{quotePrice}</span>
                  )}
                </span>
              </span>
              / {camelCaseToWords(quote)}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};
